"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function postMessage(data) {
    if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
    else {
        window.parent.postMessage(JSON.stringify(data), "*");
    }
}
exports.default = postMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zdE1lc3NhZ2UuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9saWIvZnVuY3Rpb25zL3Bvc3RNZXNzYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBTUEsU0FBd0IsV0FBVyxDQUFDLElBQVM7SUFDekMsSUFBSSxNQUFNLENBQUMsa0JBQWtCLEVBQUU7UUFDM0IsTUFBTSxDQUFDLGtCQUFrQixDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUE7S0FDOUQ7U0FBTTtRQUNILE1BQU0sQ0FBQyxNQUFNLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLEVBQUUsR0FBRyxDQUFDLENBQUE7S0FDdkQ7QUFDTCxDQUFDO0FBTkQsOEJBTUMifQ==